import moduleIntegrityCheck from "~components/shared/module/Module.integrity";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

import type { SectionFrontHeaderDefaultProps } from "./SectionFrontHeaderDefault";

export default function integrityCheck(
    props: SectionFrontHeaderDefaultProps
): IntegrityStatus {
    const messages = moduleIntegrityCheck(props);

    if (!props.title) messages.push("Missing header title");

    return messages;
}
